import { getRgObjectsOfType as s, RG_TYPE as c } from "@project-rouge/rg-core";
import { getLevelGIA as g } from "./index20.js";
import { getLevelNIA as d } from "./index25.js";
const a = (f, i) => {
  let t = 0, n = 0;
  const l = s(f, c.Building);
  for (const o of l) {
    const r = o.data.levels.filter((e) => e.levelIndex === i);
    r.every((e) => e.isRoof) || r.every((e) => e.isPodium) || (t += g(o, i), n += d(o, i));
  }
  return t === 0 ? 0 : n / t;
};
export {
  a as getLevelResidentialEfficiency
};
//# sourceMappingURL=index29.js.map
